<template>
  <div class="social-share-widget" :class="{ 'is-right-to-left-actives': isRightToLeftActives }">
    <ul>
      <li v-if="showFacebook" @click="dataLayerTagging(facebookTags)">
        <network network="facebook">
          <span
            class="icon-small fb-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ facebook }}</span>
        </network>
      </li>
      <li v-if="showGoogleplus" @click="dataLayerTagging(googlePlusTags)">
        <network network="googleplus">
          <span
            class="icon-small gplus-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ googleplus }}</span>
        </network>
      </li>
      <li v-if="showLine" @click="dataLayerTagging(lineTags)">
        <network network="line">
          <span
            class="icon-small line-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ line }}</span>
        </network>
      </li>
      <li v-if="showLinkedin" @click="dataLayerTagging(linkedinTags)">
        <network network="linkedin">
          <span
            class="icon-small linkdin-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ linkedin }}</span>
        </network>
      </li>
      <li v-if="showOdnoklassniki" @click="dataLayerTagging(odnoklassnikiTags)">
        <network network="odnoklassniki">
          <span
            class="icon-small od-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ odnoklassniki }}</span>
        </network>
      </li>
      <li v-if="showPinterest" @click="dataLayerTagging(pinterestTags)">
        <network network="pinterest">
          <span
            class="icon-small pinterest-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ pinterest }}</span>
        </network>
      </li>
      <li v-if="showReddit" @click="dataLayerTagging(redditTags)">
        <network network="reddit">
          <span
            class="icon-small reddit-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ reddit }}</span>
        </network>
      </li>
      <li v-if="showSkype" @click="dataLayerTagging(skypeTags)">
        <network network="skype">
          <span
            class="icon-small skype-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ skype }}</span>
        </network>
      </li>
      <li v-if="showTelegram" @click="dataLayerTagging(telegramTags)">
        <network network="telegram">
          <span
            class="icon-small telegram-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ telegram }}</span>
        </network>
      </li>
      <li v-if="showTwitter" @click="dataLayerTagging(twitterTags)">
        <network network="twitter">
          <span
            class="icon-small twitter-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ twitter }}</span>
        </network>
      </li>
      <li v-if="showVk" @click="dataLayerTagging(vkontakteTags)">
        <network network="vk">
          <span
            class="icon-small vk-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ vk }}</span>
        </network>
      </li>
      <li v-if="showWeibo" @click="dataLayerTagging(weiboTags)">
        <network network="weibo">
          <span
            class="icon-small weibo-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ weibo }}</span>
        </network>
      </li>
      <li v-if="showWhatsapp" @click="dataLayerTagging(whatsAppTags)">
        <network network="whatsapp">
          <span
            class="icon-small whatsapp-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ whatsapp }}</span>
        </network>
      </li>
      <li v-if="showNaver" @click="dataLayerTagging(naverTags)">
        <network network="naver">
          <span
            class="icon-small naver-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ naver }}</span>
        </network>
      </li>
      <li v-if="showTumblr" @click="dataLayerTagging(tumblerTags)">
        <network network="tumblr">
          <span
            class="icon-small tumblr-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ tumblr }}</span>
        </network>
      </li>
      <li v-if="showKakao" @click="dataLayerTagging(kakaoTags)">
        <network network="kakao">
          <span
            class="icon-small kakao-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ kakao }}</span>
        </network>
      </li>
      <li v-if="showWechat" @click="dataLayerTagging(weChatTags)">
        <network network="wechat">
          <span
            class="icon-small wechat-icon-sprite-small icon-size-circle-small-ltr"
            :class="{ 'icon-size-circle-small-rtl': isRightToLeftActives }"
          ></span>
          <span v-if="showMediatext">{{ wechat }}</span>
        </network>
      </li>
    </ul>
  </div>
</template>

<script>
import SocialSharingNetwork from './SocialSharingNetwork.vue';
import Networks from '../networks.json';

const inBrowser = typeof window !== 'undefined';
let $window = inBrowser ? window : null;

function getMetaContent(property) {
  if (typeof document === 'undefined') return '';
  const el = document.querySelector("meta[property='" + property + "']");
  return el ? el.getAttribute('content') : '';
}

const titleVal = getMetaContent('og:title');
const desc = getMetaContent('og:description');
const image = getMetaContent('og:image');

export function mockWindow(self) {
  $window = self || window;
}

export default {
  name: 'social-sharing-new',

  components: {
    network: SocialSharingNetwork,
  },

  provide() {
    return {
      networkTag: this.networkTag,
      createSharingUrl: this.createSharingUrl,
      shareFn: this.share,
      touchFn: this.touch,
    };
  },

  props: {
    /**
     * URL to share.
     * @var string
     */
    url: {
      type: String,
      default: inBrowser ? window.location.href : '',
    },
    title: {
      type: String,
      default: titleVal,
    },

    /**
     * Sharing description, if available by network.
     * @var string
     */
    description: {
      type: String,
      default: desc,
    },

    /**
     * Facebook quote
     * @var string
     */
    quote: {
      type: String,
      default: '',
    },

    /**
     * Twitter hashtags
     * @var string
     */
    hashtags: {
      type: String,
      default: '',
    },

    /**
     * Twitter user.
     * @var string
     */
    twitterUser: {
      type: String,
      default: '',
    },

    /**
     * Flag that indicates if counts should be retrieved.
     * - NOT WORKING IN CURRENT VERSION
     * @var mixed
     */
    withCounts: {
      type: [String, Boolean],
      default: false,
    },

    /**
     * Google plus key.
     * @var string
     */
    googleKey: {
      type: String,
      default: undefined,
    },

    /**
     * Pinterest Media URL.
     * Specifies the image/media to be used.
     */
    media: {
      type: String,
      default: image,
    },

    /**
     * Network sub component tag.
     * Default to span tag
     */
    networkTag: {
      type: String,
      default: 'span',
    },
    /**
     * facebook media status.
     * @var boolean
     */
    showFacebook: {
      type: Boolean,
      default: false,
    },
    /**
     * googleplus media status.
     * @var boolean
     */
    showGoogleplus: {
      type: Boolean,
      default: false,
    },
    /**
     * Line media status.
     * @var boolean
     */
    showLine: {
      type: Boolean,
      default: false,
    },
    /**
     * Linkedin media status.
     * @var boolean
     */
    showLinkedin: {
      type: Boolean,
      default: false,
    },
    /**
     * Odnoklassniki media status.
     * @var boolean
     */
    showOdnoklassniki: {
      type: Boolean,
      default: false,
    },
    /**
     * Pinterest media status.
     * @var boolean
     */
    showPinterest: {
      type: Boolean,
      default: false,
    },
    /**
     * Reddit media status.
     * @var boolean
     */
    showReddit: {
      type: Boolean,
      default: false,
    },
    /**
     * Skype media status.
     * @var boolean
     */
    showSkype: {
      type: Boolean,
      default: false,
    },
    /**
     * Telegram media status.
     * @var boolean
     */
    showTelegram: {
      type: Boolean,
      default: false,
    },
    /**
     * Twitter media status.
     * @var boolean
     */
    showTwitter: {
      type: Boolean,
      default: false,
    },
    /**
     * VK media status.
     * @var boolean
     */
    showVk: {
      type: Boolean,
      default: false,
    },
    /**
     * Weibo media status.
     * @var boolean
     */
    showWeibo: {
      type: Boolean,
      default: false,
    },
    /**
     * Whatsapp media status.
     * @var boolean
     */
    showWhatsapp: {
      type: Boolean,
      default: false,
    },
    /**
     * Naver media status.
     * @var boolean
     */
    showNaver: {
      type: Boolean,
      default: false,
    },
    /**
     * Tumblr media status.
     * @var boolean
     */
    showTumblr: {
      type: Boolean,
      default: false,
    },
    /**
     * Kakao media status.
     * @var boolean
     */
    showKakao: {
      type: Boolean,
      default: false,
    },
    /**
     * Wechat media status.
     * @var boolean
     */
    showWechat: {
      type: Boolean,
      default: false,
    },
    /**
     * Text for facebook.
     * @var string
     */
    facebook: {
      type: String,
      default: 'Facebook',
    },
    /**
     * Text for googleplus.
     * @var string
     */
    googleplus: {
      type: String,
      default: 'Googleplus',
    },
    /**
     * Text for line.
     * @var string
     */
    line: {
      type: String,
      default: 'Line',
    },
    /**
     * Text for linkedin.
     * @var string
     */
    linkedin: {
      type: String,
      default: 'Linkedin',
    },
    /**
     * Text for odnoklassniki.
     * @var string
     */
    odnoklassniki: {
      type: String,
      default: 'Odnoklassniki',
    },
    /**
     * Text for pinterest.
     * @var string
     */
    pinterest: {
      type: String,
      default: 'Pinterest',
    },
    /**
     * Text for reddit.
     * @var string
     */
    reddit: {
      type: String,
      default: 'Reddit',
    },
    /**
     * Text for skype.
     * @var string
     */
    skype: {
      type: String,
      default: 'Skype',
    },
    /**
     * Text for telegram.
     * @var string
     */
    telegram: {
      type: String,
      default: 'Telegram',
    },
    /**
     * Text for twitter.
     * @var string
     */
    twitter: {
      type: String,
      default: 'Twitter',
    },
    /**
     * Text for vk.
     * @var string
     */
    vk: {
      type: String,
      default: 'VKontakte',
    },
    /**
     * Text for weibo.
     * @var string
     */
    weibo: {
      type: String,
      default: 'Weibo',
    },
    /**
     * Text for whatsapp.
     * @var string
     */
    whatsapp: {
      type: String,
      default: 'Whatsapp',
    },
    /**
     * Text for kakao.
     * @var string
     */
    kakao: {
      type: String,
      default: 'Kakao',
    },
    wechat: {
      type: String,
      defatult: 'Wechat',
    },
    /**
     * Text for naver.
     * @var string
     */
    naver: {
      type: String,
      default: 'Naver',
    },
    /**
     * Text for tumblr.
     * @var string
     */
    tumblr: {
      type: String,
      default: 'Tumblr',
    },
    /**
     * Status for showMediatext.
     * @var boolean
     */
    showMediatext: {
      type: Boolean,
      default: true,
    },
    /**
     * facebook tag Attributes.
     * @var tagging
     */
    facebookTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    twitterTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    naverTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    lineTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    weiboTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    whatsAppTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    telegramTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    tumblerTags: {
      type: String,
      default: '',
    },
    /**
     * pinterestTags.
     * @var tagging
     */
    pinterestTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    skypeTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    googlePlusTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    redditTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    linkedinTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    odnoklassnikiTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    vkontakteTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    kakaoTags: {
      type: String,
      default: '',
    },
    /**
     * Wechat tags .
     * @var tagging
     */
    weChatTags: {
      type: String,
      default: '',
    },
    isRightToLeftActives: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      /**
       * Available sharing networks.
       * @param object
       */
      networks: Networks,
      /**
       * Popup settings.
       * @param object
       */
      popup: {
        status: false,
        resizable: true,
        toolbar: false,
        menubar: false,
        scrollbars: false,
        location: false,
        directories: false,
        width: 626,
        height: 436,
        top: 0,
        left: 0,
        window: undefined,
        interval: null,
      },
      datas: true,
    };
  },

  /**
   * Sets popup default dimensions.
   */
  mounted() {
    /* istanbul ignore next */
    if (!inBrowser) {
      return;
    }

    /**
     * Center the popup on dual screens
     * http://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen/32261263
     */
    const clientHeight = document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;
    const clientWidth = document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
    const width = $window.innerWidth ? $window.innerWidth : clientWidth;
    const height = $window.innerHeight ? $window.innerHeight : clientHeight;
    /* istanbul ignore next */
    if (this.datas) {
      const dualScreenLeft = $window.screenLeft !== undefined ? $window.screenLeft : screen.left;
      const dualScreenTop = $window.screenTop !== undefined ? $window.screenTop : screen.top;
      this.popup.left = width / 2 - this.popup.width / 2 + dualScreenLeft;
      this.popup.top = height / 2 - this.popup.height / 2 + dualScreenTop;
    }
  },

  methods: {
    /**
     * Returns generated sharer url.
     *
     * @param network Social network key.
     */
    createSharingUrl(network) {
      /* istanbul ignore next */
      return this.networks[network].sharer
        .replace(/@url/g, encodeURIComponent(this.url))
        .replace(/@title/g, encodeURIComponent(this.title))
        .replace(/@description/g, encodeURIComponent(this.description))
        .replace(/@quote/g, encodeURIComponent(this.quote))
        .replace(/@hashtags/g, this.hashtags)
        .replace(/@media/g, this.media)
        .replace(/@twitteruser/g, this.twitterUser ? '&via=' + this.twitterUser : '');
    },

    dataLayerTagging(tags) {
      /* istanbul ignore next */
      if (window.dataLayer !== undefined && tags !== '') {
        dataLayer.push(JSON.parse(tags)); // eslint-disable-line no-undef
      }
    },
    share(network) {
      /* istanbul ignore next */
      if (this.datas) {
        this.openSharer(network, this.createSharingUrl(network));
      }
      this.$root.$emit('social_shares_open', network, this.url);
    },

    /**
     * Touches network and emits click event.
     *
     * @param string network Social network key.
     */
    touch(network) {
      /* istanbul ignore next */
      window.open(this.createSharingUrl(network), '_self');
      /* istanbul ignore next */
      this.$root.$emit('social_shares_open', network, this.url);
    },

    /**
     * Opens sharer popup.
     *
     * @param string url Url to share.
     */
    openSharer(network, url) {
      // If a popup window already exist it will be replaced, trigger a close event.
      /* istanbul ignore next */
      if (this.popup.window && this.popup.interval) {
        clearInterval(this.popup.interval);
        this.popup.window.close(); // Force close (for Facebook)
        this.$root.$emit('social_shares_change', network, this.url);
      }

      /* istanbul ignore next */
      this.popup.window = window.open(
        url,
        'sharer',
        'status=' +
          (this.popup.status ? 'yes' : 'no') +
          ',height=' +
          this.popup.height +
          ',width=' +
          this.popup.width +
          ',resizable=' +
          (this.popup.resizable ? 'yes' : 'no') +
          ',left=' +
          this.popup.left +
          ',top=' +
          this.popup.top +
          ',screenX=' +
          this.popup.left +
          ',screenY=' +
          this.popup.top +
          ',toolbar=' +
          (this.popup.toolbar ? 'yes' : 'no') +
          ',menubar=' +
          (this.popup.menubar ? 'yes' : 'no') +
          ',scrollbars=' +
          (this.popup.scrollbars ? 'yes' : 'no') +
          ',location=' +
          (this.popup.location ? 'yes' : 'no') +
          ',directories=' +
          (this.popup.directories ? 'yes' : 'no'),
      );
      // this.popup.window.focus();

      // Create an interval to detect popup closing event
      /* istanbul ignore next */
      this.popup.interval = setInterval(() => {
        if (this.popup.window.closed) {
          clearInterval(this.popup.interval);
          this.popup.window = undefined;
          this.$root.$emit('social_shares_close', network, this.url);
        }
      }, 500);
    },
  },
};
</script>
